import { useEffect } from "react";
import Hero from "../components/Hero";
import FeaturedTournaments from "../components/FeaturedTournaments";
import Courses from "../components/FeaturedCourses";
import Testimonials from "../components/Testimonials";
import Queen from "../components/Queen";
import Carousel from "../components/Carousel";
import "../styles/home.css";

const Home = () => {

useEffect(() => {
  const wrapper = document.querySelector(".scroll-wrapper");
  if (!wrapper) return;

  const onScroll = () => {
    const scrollY = window.scrollY;

    const start = 180;    // wait till hero animation finishes
    const maxMove = 80;   // max movement in px

    if (scrollY > start) {
      const move = Math.min((scrollY - start) * 0.2, maxMove);
      wrapper.style.transform = `translateY(${move}px)`;
    } else {
      wrapper.style.transform = `translateY(0px)`;
    }
  };

  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
}, []);

  return (
    <div className="home-page">
      <Queen/>
      <Hero />
      <Courses />
      <FeaturedTournaments />
      <Testimonials />
      <Carousel/>
      
    </div>
  );
};

export default Home;
